/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Not found
 * @export
 * @interface GetMarketsRegionIdHistoryNotFound
 */
export interface GetMarketsRegionIdHistoryNotFound {
    /**
     * Not found message
     * @type {string}
     * @memberof GetMarketsRegionIdHistoryNotFound
     */
    error?: string;
}

/**
 * Check if a given object implements the GetMarketsRegionIdHistoryNotFound interface.
 */
export function instanceOfGetMarketsRegionIdHistoryNotFound(value: object): value is GetMarketsRegionIdHistoryNotFound {
    return true;
}

export function GetMarketsRegionIdHistoryNotFoundFromJSON(json: any): GetMarketsRegionIdHistoryNotFound {
    return GetMarketsRegionIdHistoryNotFoundFromJSONTyped(json, false);
}

export function GetMarketsRegionIdHistoryNotFoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMarketsRegionIdHistoryNotFound {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function GetMarketsRegionIdHistoryNotFoundToJSON(json: any): GetMarketsRegionIdHistoryNotFound {
    return GetMarketsRegionIdHistoryNotFoundToJSONTyped(json, false);
}

export function GetMarketsRegionIdHistoryNotFoundToJSONTyped(value?: GetMarketsRegionIdHistoryNotFound | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

